<template>
  <section>
    <!--工具条-->
    <el-form
      :inline="true"
      v-if="buttonList != null && buttonList.length > 0"
      :model="filters"
      @submit.native.prevent
    >
      <el-form-item label="规则名称">
        <el-input v-model="filters.RuleName" placeholder="请输入规则名称"></el-input>
      </el-form-item>
      <el-form-item label="证书">
        <el-select v-model="filters.CertificateId" clearable placeholder="请选择证书">
          <el-option label="全部" :value="-1"></el-option>
          <el-option
            v-for="item in certificateList"
            :key="item.Key"
            :label="item.Value"
            :value="item.Key"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="filters.Status" clearable placeholder="请选择状态">
          <el-option label="全部" :value="-1"></el-option>
          <el-option label="启用" :value="1"></el-option>
          <el-option label="禁用" :value="0"></el-option>
        </el-select>
      </el-form-item>
      <!-- 按钮由后台权限管理控制显示（buttonList）：
           - 运维按钮「立即补发」(Func=handleBatchIssue) / 「查看满足人员」(Func=handlePreviewMembers)
           需在「权限管理 → 证书规则页」下新增为按钮类型子菜单并分配给对应角色 -->
      <el-form-item v-for="item in buttonList" v-bind:key="item.id">
        <el-button :type="getButtonType(item.Func)" @click="callFunc(item)">
          {{ item.name }}
        </el-button>
      </el-form-item>
    </el-form>

    <!--列表-->
    <el-table
      :data="tableData"
      highlight-current-row
      @current-change="selectCurrentRow"
      v-loading="listLoading"
      style="width: 100%"
    >
      <el-table-column prop="Id" label="ID" width="60"></el-table-column>
      <el-table-column prop="RuleName" label="规则名称" width="150"></el-table-column>
      <el-table-column prop="CertificateName" label="关联证书" width="150"></el-table-column>
      <el-table-column prop="RuleTypeName" label="规则类型" width="100"></el-table-column>
      <el-table-column prop="ConditionLogic" label="条件逻辑" width="100">
        <template slot-scope="scope">
          <el-tag :type="scope.row.ConditionLogic === 'AND' ? 'primary' : 'warning'" size="small">
            {{ scope.row.ConditionLogic === 'AND' ? '全部满足' : '满足任一' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="IsNeedDelivery" label="需要邮寄" width="100">
        <template slot-scope="scope">
          <el-tag :type="scope.row.IsNeedDelivery ? 'success' : 'info'" size="small">
            {{ scope.row.IsNeedDelivery ? '是' : '否' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="StatusName" label="状态" width="80">
        <template slot-scope="scope">
          <el-tag :type="scope.row.Status === 1 ? 'success' : 'info'" size="small">
            {{ scope.row.StatusName }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="CreateTime" label="创建时间" width="160" :formatter="formatTime"></el-table-column>
    </el-table>

    <!--分页-->
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageIndex"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>

    <!--新增/编辑弹窗-->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="700px"
      :close-on-click-modal="false"
    >
      <el-form :model="editForm" :rules="editFormRules" ref="editForm" label-width="100px">
        <el-form-item label="规则名称" prop="RuleName">
          <el-input v-model="editForm.RuleName" placeholder="请输入规则名称"></el-input>
        </el-form-item>
        <el-form-item label="关联证书" prop="CertificateId">
          <el-select v-model="editForm.CertificateId" placeholder="请选择证书" style="width: 100%">
            <el-option
              v-for="item in certificateList"
              :key="item.Key"
              :label="item.Value"
              :value="item.Key"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="规则类型" prop="RuleType">
          <el-select v-model="editForm.RuleType" placeholder="请选择规则类型">
            <el-option label="自动发放" :value="1"></el-option>
            <el-option label="申请审核" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="条件逻辑" prop="ConditionLogic">
          <el-radio-group v-model="editForm.ConditionLogic">
            <el-radio label="AND">全部满足(AND)</el-radio>
            <el-radio label="OR">满足任一(OR)</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="需要邮寄">
          <el-switch v-model="editForm.IsNeedDelivery" active-text="是" inactive-text="否"></el-switch>
        </el-form-item>
        <el-form-item label="发放条件">
          <div class="condition-list">
            <div v-for="(condition, index) in editForm.Conditions" :key="index" class="condition-item">
              <el-select v-model="condition.ConditionType" placeholder="条件类型" style="width: 140px" @change="onConditionTypeChange(condition)">
                <el-option label="完成指定课程" :value="1"></el-option>
                <el-option label="通过指定考试" :value="2"></el-option>
                <el-option label="学习时长达标" :value="3"></el-option>
                <el-option label="完成课程数量" :value="4"></el-option>
                <el-option label="获得指定证书" :value="5"></el-option>
              </el-select>
              <!-- 完成指定课程 -->
              <el-select
                v-if="condition.ConditionType === 1"
                v-model="condition.courseId"
                placeholder="请选择课程"
                filterable
                style="width: 280px; margin-left: 10px"
              >
                <el-option
                  v-for="item in courseList"
                  :key="item.Key"
                  :label="item.Value"
                  :value="item.Key"
                ></el-option>
              </el-select>
              <!-- 通过指定考试 -->
              <el-select
                v-else-if="condition.ConditionType === 2"
                v-model="condition.examId"
                placeholder="请选择考试"
                filterable
                style="width: 280px; margin-left: 10px"
              >
                <el-option
                  v-for="item in examList"
                  :key="item.Key"
                  :label="item.Value"
                  :value="item.Key"
                ></el-option>
              </el-select>
              <!-- 学习时长达标 -->
              <el-input-number
                v-else-if="condition.ConditionType === 3"
                v-model="condition.hours"
                :min="1"
                :max="9999"
                placeholder="小时数"
                style="width: 200px; margin-left: 10px"
              ></el-input-number>
              <span v-if="condition.ConditionType === 3" style="margin-left: 5px; color: #666">小时</span>
              <!-- 完成课程数量 -->
              <el-input-number
                v-else-if="condition.ConditionType === 4"
                v-model="condition.count"
                :min="1"
                :max="999"
                placeholder="课程数量"
                style="width: 200px; margin-left: 10px"
              ></el-input-number>
              <span v-if="condition.ConditionType === 4" style="margin-left: 5px; color: #666">门课程</span>
              <!-- 获得指定证书 -->
              <el-select
                v-else-if="condition.ConditionType === 5"
                v-model="condition.certificateId"
                placeholder="请选择证书"
                filterable
                style="width: 280px; margin-left: 10px"
              >
                <el-option
                  v-for="item in certificateList"
                  :key="item.Key"
                  :label="item.Value"
                  :value="item.Key"
                ></el-option>
              </el-select>
              <el-button type="danger" icon="el-icon-delete" circle size="small" @click="removeCondition(index)" style="margin-left: 10px"></el-button>
            </div>
            <el-button type="primary" icon="el-icon-plus" size="small" @click="addCondition">添加条件</el-button>
          </div>
        </el-form-item>
        <el-form-item label="状态" prop="Status">
          <el-switch v-model="editForm.Status" :active-value="1" :inactive-value="0" active-text="启用" inactive-text="禁用"></el-switch>
        </el-form-item>
        <el-form-item label="备注">
          <el-input type="textarea" v-model="editForm.Remark" :rows="2" placeholder="请输入备注"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitForm" :loading="submitLoading">确定</el-button>
      </div>
    </el-dialog>

    <!--「查看满足人员」弹框：列表 + 单人补发-->
    <el-dialog
      title="满足规则的用户列表"
      :visible.sync="memberDialogVisible"
      width="960px"
      :close-on-click-modal="false"
      top="6vh"
    >
      <div v-if="eligibilityData" class="eligibility-header">
        <p style="margin:0 0 6px">
          规则：<b>{{ eligibilityData.RuleName }}</b>
          ｜关联证书：<b>{{ eligibilityData.CertificateName }}</b>
        </p>
        <p style="margin:0 0 10px">
          已检查 <b>{{ eligibilityData.CheckedCount }}</b> 人
          ｜满足条件 <b style="color:#409eff">{{ eligibilityData.EligibleCount }}</b> 人
          ｜已持有 <b style="color:#909399">{{ eligibilityData.OwnedCount }}</b> 人
          ｜未持有 <b style="color:#67c23a">{{ eligibilityData.NotOwnedCount }}</b> 人
          <span v-if="eligibilityData.FailedCount > 0" style="color:#f56c6c">
            ｜失败 <b>{{ eligibilityData.FailedCount }}</b> 人（详情查后端日志）
          </span>
        </p>
        <el-checkbox v-model="memberOnlyNotOwned" @change="loadEligibleMembers(1)">
          仅显示未持有（可补发候选，性能更好）
        </el-checkbox>
      </div>

      <el-table
        :data="eligibilityData ? eligibilityData.Members : []"
        v-loading="memberListLoading"
        stripe
        border
        size="small"
        style="width: 100%"
      >
        <el-table-column prop="MemberId" label="ID" width="70"></el-table-column>
        <el-table-column prop="MemberName" label="姓名" width="110" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="MemberPhone" label="手机号" width="130"></el-table-column>
        <el-table-column prop="EnterpriseName" label="企业/医院/学校" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column label="状态" width="180">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.AlreadyOwned" type="info" size="small">
              已持有 {{ formatOwnedTime(scope.row.IssueTime) }}
            </el-tag>
            <el-tag v-else type="success" size="small">未持有</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120" fixed="right">
          <template slot-scope="scope">
            <el-button
              v-if="!scope.row.AlreadyOwned"
              type="primary"
              size="mini"
              :loading="singleIssuingMemberId === scope.row.MemberId"
              @click="handleSingleIssue(scope.row)"
            >补发</el-button>
            <span v-else style="color:#909399;font-size:12px">已发放</span>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        style="margin-top: 12px; text-align: right"
        @size-change="handleMemberSizeChange"
        @current-change="handleMemberPageChange"
        :current-page="memberPageIndex"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="memberPageSize"
        :total="eligibilityData ? eligibilityData.Total : 0"
        layout="total, sizes, prev, pager, next, jumper"
      ></el-pagination>

      <div slot="footer">
        <el-button @click="memberDialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import {
  CertificateRuleGetList,
  CertificateRuleGet,
  CertificateRuleAdd,
  CertificateRuleUpdate,
  CertificateRuleDelete,
  CertificateRuleBatchIssue,
  CertificateRuleEligibleMembers,
  CertificateRuleIssueByMember,
  CertificateGetList,
  CurriculumList,
  ExaminationList,
} from '../../api/api'
import { getButtonList } from '../../promissionRouter'
import { formatDate } from '../../common/js/date'

export default {
  data() {
    return {
      filters: {
        RuleName: '',
        CertificateId: -1,
        Status: -1,
      },
      tableData: [],
      listLoading: false,
      total: 0,
      pageIndex: 1,
      pageSize: 10,
      currentRow: null,
      buttonList: [],
      certificateList: [],
      courseList: [],
      examList: [],

      dialogVisible: false,
      dialogTitle: '',
      submitLoading: false,
      editForm: {
        Id: 0,
        RuleName: '',
        CertificateId: null,
        RuleType: 1,
        ConditionLogic: 'AND',
        IsNeedDelivery: false,
        Status: 1,
        Remark: '',
        Conditions: [],
      },
      editFormRules: {
        RuleName: [{ required: true, message: '请输入规则名称', trigger: 'blur' }],
        CertificateId: [{ required: true, message: '请选择证书', trigger: 'change' }],
      },

      // 「查看满足人员」弹框状态
      memberDialogVisible: false,
      memberListLoading: false,
      memberPageIndex: 1,
      memberPageSize: 20,
      memberOnlyNotOwned: false,
      eligibilityData: null,        // RuleEligibilityListVM
      singleIssuingMemberId: null,  // 当前正在补发的用户行 MemberId（控制按钮 loading）
    }
  },
  created() {
    this.loadCertificateList()
    this.loadCourseList()
    this.loadExamList()
    this.getModules_search()
  },
  mounted() {
    // 从 localStorage 的路由树中提取当前页面的按钮权限子菜单
    // （后台「权限管理 → 证书规则页」下配置的按钮类型子菜单）
    const routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : []
    const list = getButtonList(this.$route.path, routers)
    if (list && list.length > 0) {
      this.buttonList = list
    } else {
      // 兜底：权限未配置时仅提供基础操作（运维敏感按钮不在默认列表）
      this.buttonList = [
        { id: 1, name: '查询', Func: 'getModules_search' },
        { id: 2, name: '新增', Func: 'handleAdd' },
        { id: 3, name: '编辑', Func: 'handleEdit' },
        { id: 4, name: '删除', Func: 'handleDel' },
      ]
    }
  },
  methods: {
    callFunc(item) {
      this[item.Func](item)
    },
    // 按钮染色：删除/停用类染红；运维补偿类(立即补发/查看满足人员)染黄；其余蓝色
    getButtonType(func) {
      if (!func) return 'primary'
      const f = func.toLowerCase()
      if (f.indexOf('handledel') !== -1 || f.indexOf('stop') !== -1) return 'danger'
      if (f.indexOf('handlebatchissue') !== -1 || f.indexOf('handlepreview') !== -1) return 'warning'
      return 'primary'
    },
    async loadCertificateList() {
      const { data } = await CertificateGetList({ PageIndex: 1, PageSize: 1000 })
      if (data.success) {
        this.certificateList = (data.response.data || []).map(item => ({
          Key: item.Id,
          Value: item.Name,
        }))
      }
    },
    async loadCourseList() {
      const { data } = await CurriculumList({ PageIndex: 1, PageSize: 1000 })
      if (data.success) {
        this.courseList = (data.response.data || []).map(item => ({
          Key: item.Id,
          Value: item.Subject,  // 课程名称字段是 Subject
        }))
      }
    },
    async loadExamList() {
      const { data } = await ExaminationList({ PageIndex: 1, PageSize: 1000 })
      if (data.success) {
        this.examList = (data.response.data || []).map(item => ({
          Key: item.Id,
          Value: item.Name,  // 考试名称字段是 Name
        }))
      }
    },
    async getModules_search() {
      this.listLoading = true
      const { data } = await CertificateRuleGetList({
        PageIndex: this.pageIndex,
        PageSize: this.pageSize,
        RuleName: this.filters.RuleName,
        CertificateId: this.filters.CertificateId,
        Status: this.filters.Status,
      })
      if (data.success) {
        this.tableData = data.response.data
        this.total = data.response.dataCount
        // buttonList 在 mounted() 中通过 promissionRouter.getButtonList 读取，这里不再处理
      }
      this.listLoading = false
    },
    selectCurrentRow(row) {
      this.currentRow = row
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getModules_search()
    },
    handleCurrentChange(val) {
      this.pageIndex = val
      this.getModules_search()
    },
    handleAdd() {
      this.dialogTitle = '新增发放规则'
      this.resetForm()
      this.dialogVisible = true
    },
    async handleEdit() {
      if (!this.currentRow) {
        this.$message.warning('请选择要编辑的记录')
        return
      }
      this.dialogTitle = '编辑发放规则'
      const { data } = await CertificateRuleGet({ id: this.currentRow.Id })
      if (data.success && data.response) {
        const item = data.response
        this.editForm = {
          Id: item.Id,
          RuleName: item.RuleName,
          CertificateId: item.CertificateId,
          RuleType: item.RuleType,
          ConditionLogic: item.ConditionLogic,
          IsNeedDelivery: item.IsNeedDelivery,
          Status: item.Status,
          Remark: item.Remark,
          Conditions: (item.Conditions || []).map(c => this.parseCondition(c)),
        }
        this.dialogVisible = true
      }
    },
    async handleDel() {
      if (!this.currentRow) {
        this.$message.warning('请选择要删除的记录')
        return
      }
      this.$confirm('确认删除该规则吗?', '提示', { type: 'warning' }).then(async () => {
        const { data } = await CertificateRuleDelete({ id: this.currentRow.Id })
        if (data.success) {
          this.$message.success('删除成功')
          this.getModules_search()
        } else {
          this.$message.error(data.msg)
        }
      })
    },
    // 立即检查并补发：对该规则跑一次全量用户发证检查 + 回刷历史邮寄状态
    async handleBatchIssue() {
      if (!this.currentRow) {
        this.$message.warning('请先选择要补发的规则')
        return
      }
      const row = this.currentRow
      if (row.RuleType !== 1) {
        this.$message.warning('仅"自动发放"规则支持立即补发，"申请审核"规则需用户主动申请')
        return
      }
      if (row.Status !== 1) {
        this.$message.warning('规则未启用，请先启用规则再执行补发')
        return
      }
      try {
        await this.$confirm(
          `<div style="line-height:1.7">
            将对规则 <b>「${row.RuleName}」</b>（关联证书 <b>「${row.CertificateName}」</b>）执行：<br/>
            1. 检查所有有效用户是否满足规则条件<br/>
            2. 给已满足条件且未持有证书的用户<b>补发证书</b>（含 PDF 生成 + 微信模板消息）<br/>
            3. 若证书需邮寄，回刷历史 <b>"待填写地址"</b> 状态<br/>
            <span style="color:#e6a23c">用户量较大时可能耗时数十秒，请勿关闭页面。</span>
          </div>`,
          '立即补发确认',
          {
            confirmButtonText: '确认补发',
            cancelButtonText: '取消',
            type: 'warning',
            dangerouslyUseHTMLString: true,
          }
        )
      } catch (e) {
        return // 用户取消
      }

      const loading = this.$loading({
        lock: true,
        text: '正在补发，请勿关闭页面...',
        background: 'rgba(0,0,0,0.4)',
      })
      try {
        const { data } = await CertificateRuleBatchIssue({ ruleId: row.Id })
        if (data && data.success) {
          const r = data.response || {}
          this.$alert(
            `<div style="line-height:1.8">
              <p style="margin:0 0 8px"><b>${data.msg}</b></p>
              <p style="margin:0">已检查用户：${r.CheckedCount || 0}</p>
              <p style="margin:0">已持有证书跳过：${r.AlreadyOwnedCount || 0}</p>
              <p style="margin:0">未满足条件跳过：${r.NotEligibleCount || 0}</p>
              <p style="margin:0;color:#67c23a">本次新发放：<b>${r.IssuedCount || 0}</b></p>
              <p style="margin:0;color:#409eff">回刷邮寄状态：<b>${r.DeliveryBackfilledCount || 0}</b> 条</p>
              ${r.FailedCount > 0 ? `<p style="margin:0;color:#f56c6c">失败：${r.FailedCount}（详情查后端日志）</p>` : ''}
            </div>`,
            '补发完成',
            { dangerouslyUseHTMLString: true, type: 'success', confirmButtonText: '我知道了' }
          )
          this.getModules_search()
        } else {
          this.$message.error((data && data.msg) || '补发失败')
        }
      } catch (e) {
        this.$message.error('补发请求异常，请检查网络或后端日志')
      } finally {
        loading.close()
      }
    },
    // 查看满足规则的用户列表(打开弹框)
    async handlePreviewMembers() {
      if (!this.currentRow) {
        this.$message.warning('请先选择要查看的规则')
        return
      }
      if (this.currentRow.RuleType !== 1) {
        this.$message.warning('仅"自动发放"规则支持人员预览，"申请审核"规则需用户主动申请')
        return
      }
      this.memberDialogVisible = true
      this.memberPageIndex = 1
      this.memberOnlyNotOwned = false
      this.eligibilityData = null
      await this.loadEligibleMembers(1)
    },
    // 拉取满足规则的人员列表(分页 + onlyNotOwned 过滤)
    async loadEligibleMembers(page) {
      if (!this.currentRow) return
      if (page) this.memberPageIndex = page
      this.memberListLoading = true
      try {
        const { data } = await CertificateRuleEligibleMembers({
          ruleId: this.currentRow.Id,
          pageIndex: this.memberPageIndex,
          pageSize: this.memberPageSize,
          onlyNotOwned: this.memberOnlyNotOwned,
        })
        if (data && data.success) {
          this.eligibilityData = data.response || null
        } else {
          this.$message.error((data && data.msg) || '查询失败')
          this.eligibilityData = null
        }
      } catch (e) {
        this.$message.error('查询异常，请检查网络或后端日志')
        this.eligibilityData = null
      } finally {
        this.memberListLoading = false
      }
    },
    // 单人补发(弹框内每行按钮)
    async handleSingleIssue(row) {
      try {
        await this.$confirm(
          `确认对用户「${row.MemberName || row.MemberId}」${row.MemberPhone ? '（' + row.MemberPhone + '）' : ''}补发证书「${this.eligibilityData.CertificateName}」吗？`,
          '单人补发确认',
          { confirmButtonText: '确认补发', cancelButtonText: '取消', type: 'warning' }
        )
      } catch (e) {
        return // 用户取消
      }
      this.singleIssuingMemberId = row.MemberId
      try {
        const { data } = await CertificateRuleIssueByMember({
          ruleId: this.currentRow.Id,
          memberId: row.MemberId,
        })
        if (data && data.success) {
          this.$message.success(data.msg || '补发成功')
          await this.loadEligibleMembers(this.memberPageIndex)
        } else {
          this.$message.error((data && data.msg) || '补发失败')
        }
      } catch (e) {
        this.$message.error('补发异常，请检查网络或后端日志')
      } finally {
        this.singleIssuingMemberId = null
      }
    },
    handleMemberPageChange(p) {
      this.loadEligibleMembers(p)
    },
    handleMemberSizeChange(s) {
      this.memberPageSize = s
      this.loadEligibleMembers(1)
    },
    formatOwnedTime(t) {
      if (!t) return ''
      return '(' + formatDate(new Date(t), 'yyyy-MM-dd') + ')'
    },
    resetForm() {
      this.editForm = {
        Id: 0,
        RuleName: '',
        CertificateId: null,
        RuleType: 1,
        ConditionLogic: 'AND',
        IsNeedDelivery: false,
        Status: 1,
        Remark: '',
        Conditions: [],
      }
    },
    addCondition() {
      this.editForm.Conditions.push({
        ConditionType: 1,
        courseId: null,
        examId: null,
        hours: 1,
        count: 1,
        certificateId: null,
        Sort: this.editForm.Conditions.length,
      })
    },
    removeCondition(index) {
      this.editForm.Conditions.splice(index, 1)
    },
    onConditionTypeChange(condition) {
      // 重置条件值
      condition.courseId = null
      condition.examId = null
      condition.hours = 1
      condition.count = 1
      condition.certificateId = null
    },
    // 解析条件（从JSON到字段）
    parseCondition(c) {
      const condition = {
        ConditionType: c.ConditionType,
        Sort: c.Sort,
        courseId: null,
        examId: null,
        hours: 1,
        count: 1,
        certificateId: null,
      }
      try {
        const val = JSON.parse(c.ConditionValue || '{}')
        switch (c.ConditionType) {
          case 1: condition.courseId = val.courseId; break
          case 2: condition.examId = val.examId; break
          case 3: condition.hours = val.hours || 1; break
          case 4: condition.count = val.count || 1; break
          case 5: condition.certificateId = val.certificateId; break
        }
      } catch (e) {}
      return condition
    },
    // 构建条件（从字段到JSON）
    buildConditionValue(condition) {
      switch (condition.ConditionType) {
        case 1: return JSON.stringify({ courseId: condition.courseId })
        case 2: return JSON.stringify({ examId: condition.examId })
        case 3: return JSON.stringify({ hours: condition.hours })
        case 4: return JSON.stringify({ count: condition.count })
        case 5: return JSON.stringify({ certificateId: condition.certificateId })
        default: return '{}'
      }
    },
    submitForm() {
      this.$refs.editForm.validate(async (valid) => {
        if (valid) {
          this.submitLoading = true
          // 构建提交数据，转换条件为JSON格式
          const submitData = {
            ...this.editForm,
            Conditions: this.editForm.Conditions.map((c, idx) => ({
              ConditionType: c.ConditionType,
              ConditionValue: this.buildConditionValue(c),
              Sort: idx,
            })),
          }
          let res
          if (this.editForm.Id > 0) {
            res = await CertificateRuleUpdate(submitData)
          } else {
            res = await CertificateRuleAdd(submitData)
          }
          this.submitLoading = false
          if (res.data.success) {
            this.$message.success(this.editForm.Id > 0 ? '编辑成功' : '新增成功')
            this.dialogVisible = false
            this.getModules_search()
          } else {
            this.$message.error(res.data.msg)
          }
        }
      })
    },
    formatTime(row) {
      if (!row.CreateTime) return ''
      return formatDate(new Date(row.CreateTime), 'yyyy-MM-dd hh:mm')
    },
  },
}
</script>

<style scoped>
.condition-list {
  border: 1px solid #ebeef5;
  padding: 15px;
  border-radius: 4px;
  background: #fafafa;
}
.condition-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.condition-tip {
  font-size: 12px;
  color: #999;
  margin-top: 10px;
}
.eligibility-header {
  padding: 10px 14px;
  margin-bottom: 10px;
  background: #f5f7fa;
  border-left: 3px solid #409eff;
  border-radius: 2px;
  font-size: 13px;
  line-height: 1.6;
}
</style>
